module.exports = __webpack_public_path__ + "static/img/s173.3feaaf6a.png";